import React from "react"
import styled from "styled-components/macro"

export const Acc2Gradient = (): JSX.Element => {
  return (
    <S_Acc2Gradient
      width="25"
      height="25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="acc2Gradient">
          <stop offset="5%" stopColor="#BC904E" />
          <stop offset="95%" stopColor="#A33816" />
        </linearGradient>
      </defs>
    </S_Acc2Gradient>
  )
}

export const S_Acc2Gradient = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 0px;
  height: 0px;
`
